// extracted by mini-css-extract-plugin
export var skipAnimation = "_v-0";